function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import _styled from "@emotion/styled/base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from 'react';
import { withPrefix } from 'gatsby';
import { TopLevelNavigationItem } from './top-level-navigation-item';
import { NavigationItem } from './NavigationItem';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

var List = _styled("ul", process.env.NODE_ENV === "production" ? {
  target: "ehe2r5j0"
} : {
  target: "ehe2r5j0",
  label: "List"
})(process.env.NODE_ENV === "production" ? {
  name: "vj2tji",
  styles: "list-style:none;padding-top:0.5rem;padding-bottom:0;margin:0"
} : {
  name: "vj2tji",
  styles: "list-style:none;padding-top:0.5rem;padding-bottom:0;margin:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var _ref4 = process.env.NODE_ENV === "production" ? {
  name: "6sykm0",
  styles: "overflow-y:auto;position:relative;flex:1 1 0;-webkit-overflow-scrolling:touch;::-webkit-scrollbar{width:6px;height:6px;}::-webkit-scrollbar-thumb{background:#ccc;}"
} : {
  name: "1gqvdzc-Navigation",
  styles: "overflow-y:auto;position:relative;flex:1 1 0;-webkit-overflow-scrolling:touch;::-webkit-scrollbar{width:6px;height:6px;}::-webkit-scrollbar-thumb{background:#ccc;};label:Navigation;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

export var Navigation = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Navigation, _React$PureComponent);

  var _super = _createSuper(Navigation);

  function Navigation(props) {
    var _this;

    _classCallCheck(this, Navigation);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "navigationGroups", void 0);

    _defineProperty(_assertThisInitialized(_this), "initializaNavigationState", function (config) {
      // eslint-disable-next-line
      _this.state = config.reduce(function (acc, c) {
        acc["".concat(c.tag, "Deltas")] = [];
        return acc;
      }, {});
    });

    _defineProperty(_assertThisInitialized(_this), "restoreNavigationState", function () {
      if (typeof window !== 'undefined') {
        var restoredState = _this.readNavigationState();

        if (restoredState) {
          console.log('Restoring navigation state'); // eslint-disable-next-line

          _this.state = restoredState;
        } else {
          console.log('[New Site!]: clearing persisted navigation state');

          _this.clearNavigationState();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createNavigationGroups", function (config) {
      _this.navigationGroups = config.map(function (c) {
        var title = c.title,
            tag = c.tag;
        return _this.createNavigationGroupForTag({
          title: title,
          tag: tag
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "readNavigationState", function () {
      var stateJSON = window.localStorage.getItem('navigation');
      return _this.validNavigationState(stateJSON);
    });

    _defineProperty(_assertThisInitialized(_this), "clearNavigationState", function () {
      window.localStorage.clear();
    });

    _defineProperty(_assertThisInitialized(_this), "validNavigationState", function (stateJSON) {
      if (stateJSON) {
        var restoredState = JSON.parse(stateJSON);
        var restoredStateKeys = Object.keys(restoredState);
        var currentStateKeys = Object.keys(_this.state);

        if (currentStateKeys.every(function (e) {
          return restoredStateKeys.includes(e);
        })) {
          return restoredState;
        }
      }

      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "createNavigationGroupForTag", function (_ref) {
      var title = _ref.title,
          tag = _ref.tag;
      return {
        title: title,
        docs: _this.props.docs.filter(function (d) {
          return d.node.frontmatter.tag === tag;
        }),
        tag: tag
      };
    });

    _defineProperty(_assertThisInitialized(_this), "aggregateDeltas", function (deltas) {
      if (deltas.length > 0) {
        return deltas.reduce(function (acc, val) {
          return acc + val;
        });
      }

      return 0;
    });

    _defineProperty(_assertThisInitialized(_this), "isActive", function (docs) {
      if (docs && docs.length > 0) {
        var filtered = docs.filter(function (d) {
          return withPrefix(d.node.frontmatter.path) === _this.props.location.pathname.replace(/\/$/, '');
        });
        return filtered.length > 0;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "updateDeltas", function (tag, index, d) {
      var deltas = _toConsumableArray(_this.state["".concat(tag, "Deltas")]);

      deltas[index] = d;
      deltas = _toConsumableArray(deltas).map(function (d) {
        if (d === undefined) {
          return 0;
        }

        return d;
      });

      _this.setState(_defineProperty({}, "".concat(tag, "Deltas"), deltas));
    });

    _defineProperty(_assertThisInitialized(_this), "calculateRequiredScroll", function (_ref2) {
      var top = _ref2.top,
          addedContentHeight = _ref2.addedContentHeight,
          navigationElementTotalHeight = _ref2.navigationElementTotalHeight;
      var clientHeight = _this.scrollerRef.current.clientHeight;
      var requiredHeight = top + navigationElementTotalHeight + addedContentHeight;
      var currentHeight = clientHeight + _this.scrollerRef.current.scrollTop;
      return requiredHeight - currentHeight;
    });

    _defineProperty(_assertThisInitialized(_this), "scrollBy", function (scrollAmount) {
      _this.scrollerRef.current.scrollTop += scrollAmount;
    });

    _defineProperty(_assertThisInitialized(_this), "updateScrollPosition", function (_ref3) {
      var top = _ref3.top,
          addedContentHeight = _ref3.addedContentHeight,
          navigationElementTotalHeight = _ref3.navigationElementTotalHeight;

      if (addedContentHeight > 0 && _this.scrollerRef.current) {
        setTimeout(function () {
          var requiredScroll = _this.calculateRequiredScroll({
            top: top,
            addedContentHeight: addedContentHeight,
            navigationElementTotalHeight: navigationElementTotalHeight
          });

          if (requiredScroll > 0) {
            _this.scrollBy(requiredScroll);
          }
        }, 500);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getElementHeight", function (el) {
      if (typeof window !== 'undefined') {
        return Number(/\d+/.exec(window.getComputedStyle(el).height)[0]);
      }

      return 0;
    });

    _defineProperty(_assertThisInitialized(_this), "topLevelNavigationItemChanged", function (delta, element, triggerElement) {
      var navigationElementTotalHeight = _this.getElementHeight(triggerElement);

      _this.updateScrollPosition({
        top: element.offsetTop,
        addedContentHeight: delta,
        navigationElementTotalHeight: navigationElementTotalHeight
      });
    });

    _defineProperty(_assertThisInitialized(_this), "midLevelNavigationItemChanged", function (tag, index, delta, element, triggerElement) {
      _this.updateDeltas(tag, index, delta);

      var navigationElementTotalHeight = _this.getElementHeight(triggerElement);

      _this.updateScrollPosition({
        top: element.offsetTop,
        addedContentHeight: delta,
        navigationElementTotalHeight: navigationElementTotalHeight
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderNavigationGroup", function (group) {
      return _jsx(TopLevelNavigationItem, {
        tag: group.tag,
        title: group.title,
        onChange: function onChange(delta, el, triggerElement) {
          return _this.topLevelNavigationItemChanged(delta, el, triggerElement);
        },
        active: _this.isActive(group.docs),
        delta: _this.aggregateDeltas(_this.state["".concat(group.tag, "Deltas")]),
        children: _jsx("div", {
          children: _jsx(List, {
            children: group.docs.map(function (doc, i) {
              return _jsx(NavigationItem, _objectSpread(_objectSpread({
                location: _this.props.location
              }, doc), {}, {
                onChange: function onChange(delta, el, triggerElement) {
                  return _this.midLevelNavigationItemChanged(group.tag, i, delta, el, triggerElement);
                }
              }), i);
            })
          })
        })
      }, group.tag);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnScroll", function (e) {
      clearTimeout(_this.scrollTimer);
      _this.scrollTimer = setTimeout(function () {
        if (_this.scrollerRef.current) {
          _this.scrollerRef.current.scrollTop = Math.max(1, Math.min(_this.scrollerRef.current.scrollTop, _this.scrollerRef.current.scrollHeight - _this.scrollerRef.current.clientHeight - 1));
        }
      }, 200);
    });

    _this.scrollerRef = /*#__PURE__*/React.createRef();
    var confluenzaConfig = _this.props.confluenzaConfig;

    _this.initializaNavigationState(confluenzaConfig);

    _this.restoreNavigationState();

    _this.createNavigationGroups(confluenzaConfig);

    return _this;
  }

  _createClass(Navigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollerRef.current.scrollTop = Math.max(1, Math.min(this.scrollerRef.current.scrollTop, this.scrollerRef.current.scrollHeight - this.scrollerRef.current.clientHeight - 1));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('navigation', JSON.stringify(this.state));
      }
    } // This is insane, but seem to do miracles on iOS: https://stackoverflow.com/a/51998690/1272679

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _jsx("div", {
        onScroll: this.handleOnScroll,
        ref: this.scrollerRef,
        css: _ref4,
        children: this.navigationGroups.map(function (g) {
          return _this2.renderNavigationGroup(g);
        })
      });
    }
  }]);

  return Navigation;
}(React.PureComponent);